export const CAROUSEL_PROPERTY_LIMIT = 8;

export const YOUR_TEAM_CAROUSEL_NAME = 'Tour these homes with your agent';
